<script>
  import {onMount} from 'svelte';
  import PDFIcon from '@static/img/icons/pdf.svg';
  import CloseImg from '@static/img/close.svg';
  export let data;

  let initialBodyOverflow;
  let fullScreen = false;
  let isMobile = true;
  let isTerminal;
  let style = `padding-bottom: ${data.height * 50/data.width}%;`;
  
  const setStyle = () => {
    style = `padding-bottom: ${data.height * 50 * (isMobile ? 2 : 1)/data.width}%;`
  }

  $: setStyle(isMobile);
  

  const fullScreenHandle = e => {
    initialBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    fullScreen = true;
  }

  const closeFullScreenHandle = () => {
    document.body.style.overflow = initialBodyOverflow;
    fullScreen = false;
  }

  onMount(() => {
    isMobile = localStorage.windowWidth < 1200;
    isTerminal = localStorage.isTerminal;
  });
</script>

<div class="pdf-block" class:zoomed="{fullScreen}">
  {#if data && data.pdf_id}
    {#if fullScreen}
      <div class="aspect-ratio" style="{style}">
        <div class="aspect-ratio-content">
          <!-- <figure class='pdf-figure'> -->
            <iframe
              src="{`https://pdf.njerusalem.ru/${(isMobile && !isTerminal) ? 'mob_pdf' : 'pdf'}/${data.pdf_id}`}"
              frameborder="0"
              width="100%"
              height="100%"
              allowfullscreen
            ></iframe>
          <!-- </figure> -->
        </div>
      </div>
      <div class="zoomed-cross" on:click="{closeFullScreenHandle}">{@html CloseImg}</div>
    {:else}
      <div class="pdf-image-wrapper" on:click="{fullScreenHandle}">
        <img src="{data.src}" class="wrapper-img"/>
        <div class="pdf-icon">{@html PDFIcon}</div>
      </div>
    {/if}
  {/if}
</div>

<style>
  .aspect-ratio {
    position: relative;
    height: 0;
    overflow: hidden;
    max-height: 100vh;
    .aspect-ratio-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .pdf-block {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2.5rem;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #ffffff;
    }
  }

  .zoomed {
    position: fixed;
    top: 0;
    height: 100vh;
    left: 0;
    width: 100vw;
    z-index: 10;
    background-color: #fff;

    iframe {
      position: fixed;
    }
  }

  .zoomed-cross {
    display: block;
    z-index: 2;
    position: fixed;
    top: 0;
    height: 40px;
    right: 0;
    width: 40px;
    background-color: #0c6954;
    cursor: pointer;
  }

  .zoomed-cross.hidden {
    display: none;
  }

  :global(.zoomed-cross rect) {
    &:nth-child(1) {
      fill: transparent;
    }
  }

  .hidden {
    display: none;
  }

  .pdf-image-wrapper {
    width: 100%;
    text-align: center;
    position: relative;
    cursor: pointer;
    transform: scale(1);
    transition: transform .2s;
  }

  .pdf-image-wrapper:hover {
    transform: scale(1.07);
  }

  .pdf-image-wrapper .wrapper-img {
    box-shadow: 6px 6px 3px 0px rgb(0 0 0 / 28%);
    max-width: 80%;
    position: relative;
    margin: auto;
    @media (max-width: 1200px) {
      max-width: 100%;
    }
  }

  .pdf-image-wrapper .pdf-icon {
    display: none;
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /* display: flex; */
    align-items: center;
    justify-content: center;
    opacity: .6;
  }

  :global(.pdf-icon svg) {
    max-width: 50%;
    max-height: 50%;
  }
</style>